/* -----------------------------------------------------------------------------------------------------
  - Created: [31-01-2025] by [SREERAJ]
  - Modified: [27-06-2025] by [SREERAJ]
  - Description: This file contains Sidebar menus 
  -------------------------------------------------------------------------------------------------------
*/
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SidebarMenuComponent.css';
import useScreenSize from '../../../utils/useScreenSize';

const SidebarMenuComponent = ({ menu, icon, text, mainMenu, activeMenu, handleLogoutClick, toggleSidebar }) => {
    const { width, height } = useScreenSize();
    const [isMainHovered, setIsMainHovered] = useState(false); // Track main menu hover
    const [isSubmenuHovered, setIsSubmenuHovered] = useState(false); // Track submenu hover

    const navigate = useNavigate();

    const handleNavigation = (routeLink) => {

        if (routeLink === `logout`) { //FOR CHECK THE SIDEBAR MENU CLICK IS LOGOUT OR NOT
            handleLogoutClick()
        } else {
            navigate(`${routeLink}`);
            if (width < 1024) { //auto close when select menu in tablet and mobile devices
                toggleSidebar()
            }
        }

    }
    const isActive = activeMenu === menu?.text?.toLowerCase();  // Check if the current menu is active
    const isHovered = isMainHovered || isSubmenuHovered;
    const isHighlightmainMenu = isActive || isMainHovered || isSubmenuHovered;
    const hasSubmenus = Boolean(mainMenu && mainMenu[0]?.submenus?.length > 0) //check the menus have submenus

    return (
        <div className="sidebar">
            <div className="menuItem">
                <div
                    className={`iconContainer ${isHighlightmainMenu ? 'active_iconContainer' : ''}`}
                    onClick={() => !hasSubmenus && handleNavigation(mainMenu[0]?.link)} //ONLY NAVIGATE WHEN NO SUBMENUS
                    onMouseEnter={() => setIsMainHovered(true)}   // Main menu hover effect
                    onMouseLeave={() => setIsMainHovered(false)}
                >
                    <div className={`icon ${isHighlightmainMenu ? 'active_icon' : ''}`}>{icon}</div>
                    <div className={`menuText ${isHighlightmainMenu ? 'active_menuText' : ''}`}>{text}</div>
                </div>

                {hasSubmenus && isHovered && (

                    <div
                        className="submenuContainer"
                        onMouseEnter={() => setIsSubmenuHovered(true)}  // Show mainMenu on hover
                        onMouseLeave={() => setIsSubmenuHovered(false)}
                    >
                        {mainMenu.map((menu, subIndex) => (
                            <div key={subIndex} className="submenu">
                                {menu?.submenus && (
                                    <div className="subSubmenuContainer">
                                        {menu.submenus.map((subSubmenu, subSubIndex) => (
                                            <div
                                                key={subSubIndex}
                                                className="subSubmenu"
                                                onClick={() => {
                                                    handleNavigation(subSubmenu?.link);  // Navigate when clicked
                                                    setIsSubmenuHovered(false); // Close submenu after navigation   
                                                }}
                                            >
                                                <div className="submenu-iconContainer">
                                                    {subSubmenu.icon} {subSubmenu.name}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SidebarMenuComponent;